import React from 'react';
import { FlightAwareHub } from '../signalr/flightawarehub';
import { RouteComponentProps } from 'react-router';
import { fetch, FlightLegViewModel } from '../models/flightleg';
import { TrackingMap } from '../components/flight/trackingmap';
import { FlightExpired } from '../components/flight/flightexpired';

export interface MapParams {
    flightToken: string;
}

interface MapProps extends RouteComponentProps<MapParams> {
    flightAwareHub: FlightAwareHub;
    children?: never;
}

interface MapState {
    flightLeg?: FlightLegViewModel;
}

export class Map extends React.PureComponent<MapProps, MapState>{

    state: MapState = {}

    componentDidMount() {
        const {
            flightToken
        } = this.props.match.params;

        fetch(`api/tracking/GetFlightLegData?token=${flightToken}`)
            .then(flightLeg => this.setState({ flightLeg }));
    }
    
    render() {  
        if (this.state.flightLeg && this.state.flightLeg.expired) {
            return <FlightExpired />
        } else {
            return !!this.state.flightLeg && <TrackingMap {...this.props} {...this.state.flightLeg} /> 
        }   
    }
}
